import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../API';
import { logFrontendActivity } from '../General/activityLogger';

export const dashboardslice = createSlice({
    name: 'dashboard',
    initialState: {
        labelsearch:{
            label: "",
            message: "",
            loading: false,
            hasErrors: false
        },
        departurescan:{
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        }

    },
    reducers: {
        fetchLabel: (state) => {
            return {
                ...state,
                labelsearch: {
                    ...state.labelsearch,
                    loading: true
                }
            }
        },
        fetchLabelSuccess: (state, action) => {
            return {
                ...state,
                labelsearch: {
                    ...state.labelsearch,
                    label: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data,
                    message: "",
                    loading: false,
                    hasErrors: false
                }
            }
        },
        fetchLabelFailure: (state, action) => {
            return {
                ...state,
                labelsearch: {
                    ...state.labelsearch,
                    label: "",
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    hasErrors: true
                }
            }
        },
        departureScanData: (state) => {
            return {
                ...state,
                departurescan: {
                    ...state.departurescan,
                    loading: true
                }
            }
        },
        departureScanDataSuccess: (state, action) => {
            return {
                ...state,
                departurescan: {
                    ...state.departurescan,
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
                    loading: false,
                }
            }
        },
        departureScanDataFailure: (state, action) => {
            return {
                ...state,
                departurescan: {
                    ...state.departurescan,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" },
                    loading: false,
                }
            }
        },
        resetLabel: (state, action) => {
            return {
                ...state,
                labelsearch: {
                    label: "",
                    message: "",
                    loading: false,
                    hasErrors: false
                },
                departurescan: {
                    notification: { show: false, messageContent: "", messageType: "success" }
                }
            }
        }
    }
})

export const { fetchLabel, fetchLabelSuccess, fetchLabelFailure, resetLabel } = dashboardslice.actions;

export const fetchLabelData = meta => dispatch => {
    dispatch(fetchLabel())
    try {
        const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');
        LABELGENAPI.get('/dashboard/fetch-label?'+qs)
            .then(function (response) {
                dispatch(fetchLabelSuccess(response));
            }).catch(function (error) {
                dispatch(fetchLabelFailure(error.response));
            })
    }
    catch (error) {
        dispatch(fetchLabelFailure(error.response))
    }
}
export const { departureScanData, departureScanDataSuccess, departureScanDataFailure } = dashboardslice.actions;

export const departureScan = (userid,data) => {
    return (dispatch) => {
        dispatch((departureScanData()));
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/settings/departurescan',data)
                .then(function (response) {
                    dispatch(departureScanDataSuccess(response));
                    logFrontendActivity({
                        group: 'DEPARTURE_SCAN',
                        subgroup: 'DASHBOARD',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(departureScanDataFailure(error.response));
                    logFrontendActivity({
                        group: 'DEPARTURE_SCAN',
                        subgroup: 'DASHBOARD',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    }); 
                });
        } catch (error) {
            dispatch(departureScanDataFailure());
            logFrontendActivity({
                group: 'DEPARTURE_SCAN',
                subgroup: 'DASHBOARD',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const resetLabelData = data => dispatch => {
    dispatch(resetLabel());
}
export default dashboardslice.reducer;